export function getDefaultFilter(filters) {
  return filters.find((f) => f.default);
}

export function getDefaultFilterForAssistant(filters) {
  return filters.find((f) => f.resource === 'reminder' && f.default);
}
